import { render } from "./GreenBox3.vue?vue&type=template&id=d6c08ffe"
import script from "./GreenBox3.vue?vue&type=script&lang=js"
export * from "./GreenBox3.vue?vue&type=script&lang=js"

import "./GreenBox3.vue?vue&type=style&index=0&id=d6c08ffe&lang=css"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__